import axios from "axios";

export default function FulfillmentItemShowService(fulfillmentId, itemId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/fulfillment/" + fulfillmentId + "/item/" + itemId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
